import { TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { PropsWithChildren } from 'react';

type StatusText = PropsWithChildren & {
    variant: 'success' | 'error';
    size?: 'lg' | 'sm' | 'xlg';
};

export const StatusText = ({ children, size, variant }: StatusText) => {
    return (
        <TextPassage
            size={size}
            className={cn({
                'sparky-u-color-utility-error': variant === 'error',
                'sparky-u-color-utility-success': variant === 'success',
            })}
        >
            {children}
        </TextPassage>
    );
};
